import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import * as React from 'react';

export const initializeBugsnag = (apiKey) => {
  if (!apiKey) return null;

  Bugsnag.start({
    apiKey: apiKey,
    appVersion: process.env.APP_VERSION,
    releaseStage: process.env.APP_ENV,
    enabledReleaseStages: ['production', 'staging'],
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
      Bugsnag.addMetadata('event', [event.originalError]);

      const routesToMask = [
        '/password/reset/<secret>',
        '/aanmelden/met-code/<secret>',
      ];

      const match = routesToMask.find(route => shouldRedactToken(event.request.url, route));
      if (match) {
        event.request.url = redactToken(event.request.url, match);
        event.context = redactToken(event.context, match);

        // Redact secrets from stacktrace
        event.errors.forEach(error => {
          error.stacktrace.forEach(frame => {
            if (shouldRedactToken(frame.file, match)) {
              frame.file = redactToken(frame.file, match);
            }
          });
        })
      }
    },
    redactedKeys: ['targetText']
  });

  return Bugsnag.getPlugin('react').createErrorBoundary(React);
};

const Fallback = () => {
  return (
    <div>
      Er is iets mis gegaan, klik <a href="/">hier</a> om terug te gaan naar de applicatie.
    </div>
  );
};

export const withBugsnag = (Component, apiKey) => {
  const ErrorBoundary = initializeBugsnag(apiKey);
  
  if (!ErrorBoundary) {
    return Component; 
  }

  return (props) => (
    <ErrorBoundary FallbackComponent={Fallback}>
      <Component {...props} />
    </ErrorBoundary>
  );
}; 

function createRegexForRoute(match) {
  // Split the pattern into parts before and after <secret>
  const parts = match.split('<secret>');
  const beforeSecret = parts[0].replace(/\//g, '\\/');
  const afterSecret = parts[1] ? parts[1].replace(/\//g, '\\/') : '';
  
  // Create a pattern that captures everything before and after the secret
  return new RegExp(`(https?:\\/\\/[^/]+)?(${beforeSecret})[^/]+(${afterSecret})`);
}

export function shouldRedactToken(url, match) {
  const regex = createRegexForRoute(match);
  return regex.test(url);
}

export function redactToken(url, match) {
  const regex = createRegexForRoute(match);
  return url.replace(regex, '$1$2__REDACTED__$3');
}